import { Component, inject, signal } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DxTreeViewModule, DxTreeViewTypes } from 'devextreme-angular/ui/tree-view';

interface AdminNavItem {
  id: string;
  text: string;
  icon: string;
  route: string;
  selected?: boolean;
}

const NAV_ITEMS: AdminNavItem[] = [
  { id: 'dashboard',  text: 'Dashboard',     icon: 'home',     route: '/admin/dashboard' },
  { id: 'tenants',    text: 'Tenants',       icon: 'group',    route: '/admin/tenants' },
  { id: 'users',      text: 'Usuários',      icon: 'user',     route: '/admin/users' },
  { id: 'queues',     text: 'Filas',         icon: 'box',      route: '/admin/queues' },
  { id: 'schedules',  text: 'Agendamentos',  icon: 'event',    route: '/admin/schedules' },
  { id: 'platforms',  text: 'Plataformas',   icon: 'globe',    route: '/admin/platforms' },
  { id: 'logs',       text: 'Logs',          icon: 'bookmark', route: '/admin/logs' },
];

@Component({
  selector: 'admin-sidenav',
  standalone: true,
  imports: [DxTreeViewModule],
  templateUrl: './admin-sidenav.component.html',
  styleUrl: './admin-sidenav.component.scss',
})
export class AdminSidenavComponent {
  private readonly router = inject(Router);

  readonly navItems = signal<AdminNavItem[]>(this.markSelected(this.router.url));

  constructor() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntilDestroyed())
      .subscribe(e => {
        const url = (e as NavigationEnd).urlAfterRedirects;
        this.navItems.set(this.markSelected(url));
      });
  }

  onItemClick(e: DxTreeViewTypes.ItemClickEvent): void {
    const item = e.itemData as AdminNavItem | undefined;
    if (item?.route) {
      this.router.navigateByUrl(item.route);
    }
  }

  private markSelected(url: string): AdminNavItem[] {
    return NAV_ITEMS.map(item => ({
      ...item,
      selected: url.startsWith(item.route),
    }));
  }
}
